var EventsRegistry = /** @class */ (function () {
    function EventsRegistry() {
        this.eventHandlers = {};
    }
    EventsRegistry.prototype.updateHandler = function (element, event, callback) {
        // Remove previously registered listener
        var storedEventHandler = this.eventHandlers[event];
        if (storedEventHandler) {
            if (storedEventHandler.originalCallback === callback) {
                return;
            }
            element.removeEventListener('awsui:' + event, storedEventHandler.wrappedCallback);
            delete this.eventHandlers[event];
        }
        if (callback === undefined || callback === null) {
            return;
        }
        if (typeof callback !== 'function') {
            throw new Error("The event handler you specified for awsui:" + event + " is invalid, it can be either a function, null or undefined.");
        }
        var eventHandler = {
            originalCallback: callback,
            wrappedCallback: function (event) {
                // Only apply if the event was triggered by the same element that
                // defined the handler.
                if (event.target === element) {
                    callback(event);
                }
            }
        };
        element.addEventListener('awsui:' + event, eventHandler.wrappedCallback);
        this.eventHandlers[event] = eventHandler;
    };
    return EventsRegistry;
}());
export default EventsRegistry;
//# sourceMappingURL=EventsRegistry.js.map